import { styled } from '@mui/material/styles'

import { Button } from '../Button/Button'

export const StyledSocialButton = styled(Button)`
  color: ${(props) => props.theme.palette.text.primary};
  border: 1px solid ${(props) => props.theme.palette.text.primary};
  height: ${(props) => props.theme.typography.pxToRem(48)};
  width: 100%;

  &:hover {
    border: 1px solid ${(props) => props.theme.palette.text.primary};
    background-color: rgba(0, 0, 0, 0.1);
  }
`
